// /clients szegmens layout-ja — csak auth-guard + <Outlet/>. A tényleges oldalak a gyerek-route-okban:
// clients.index (lista) · clients.new (create) · clients.$id (detail/edit). Így a lista full-page marad,
// és a create/edit KÜLÖN teljes oldal (nem modal) — a build-design UX-szabálya szerint (Clients = full-page).
import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireAuth } from '@/lib/auth';

export const Route = createFileRoute('/clients')({
  beforeLoad: () => requireAuth(),
  component: ClientsLayout,
});

function ClientsLayout(): JSX.Element {
  return <Outlet />;
}
